import { CouponItemDto } from "./CouponItemDto";
import { ProductItemDto } from "./ProductItemDto";
import { ShipmentDto } from "./ShipmentDto";
import { ShippingMethodDto } from "./ShippingMethodDto";
import { ShippingItemDto } from "./ShippingItemDto";
import { ResponseEventDto } from "../Common";
var BasketDto = (function () {
    function BasketDto(adjustedMerchandizeTotalTax, adjustedShippingTotalTax, couponItems, currency, id, merchandizeTotalTax, miniCartLabel, orderDiscount, orderTotal, productItems, productSubTotal, productQuantity, productTotal, shippingMethodName, shipments, shippingMethods, shippingItems, shippingTotal, shippingTotalTax, taxTotal, validationError, responseEvents) {
        if (adjustedMerchandizeTotalTax === void 0) { adjustedMerchandizeTotalTax = 0; }
        if (adjustedShippingTotalTax === void 0) { adjustedShippingTotalTax = 0; }
        if (couponItems === void 0) { couponItems = []; }
        if (currency === void 0) { currency = ''; }
        if (id === void 0) { id = ''; }
        if (merchandizeTotalTax === void 0) { merchandizeTotalTax = 0; }
        if (miniCartLabel === void 0) { miniCartLabel = ''; }
        if (orderDiscount === void 0) { orderDiscount = 0; }
        if (orderTotal === void 0) { orderTotal = 0; }
        if (productItems === void 0) { productItems = []; }
        if (productSubTotal === void 0) { productSubTotal = 0; }
        if (productQuantity === void 0) { productQuantity = 0; }
        if (productTotal === void 0) { productTotal = 0; }
        if (shippingMethodName === void 0) { shippingMethodName = ''; }
        if (shipments === void 0) { shipments = []; }
        if (shippingMethods === void 0) { shippingMethods = []; }
        if (shippingItems === void 0) { shippingItems = []; }
        if (shippingTotal === void 0) { shippingTotal = 0; }
        if (shippingTotalTax === void 0) { shippingTotalTax = 0; }
        if (taxTotal === void 0) { taxTotal = 0; }
        if (validationError === void 0) { validationError = ''; }
        this.adjustedMerchandizeTotalTax = adjustedMerchandizeTotalTax;
        this.adjustedShippingTotalTax = adjustedShippingTotalTax;
        this.couponItems = couponItems;
        this.currency = currency;
        this.id = id;
        this.merchandizeTotalTax = merchandizeTotalTax;
        this.miniCartLabel = miniCartLabel;
        this.orderDiscount = orderDiscount;
        this.orderTotal = orderTotal;
        this.productItems = productItems;
        this.productSubTotal = productSubTotal;
        this.productQuantity = productQuantity;
        this.productTotal = productTotal;
        this.shippingMethodName = shippingMethodName;
        this.shipments = shipments;
        this.shippingMethods = shippingMethods;
        this.shippingItems = shippingItems;
        this.shippingTotal = shippingTotal;
        this.shippingTotalTax = shippingTotalTax;
        this.taxTotal = taxTotal;
        this.validationError = validationError;
        this.responseEvents = responseEvents;
    }
    BasketDto.fromOcapi = function (ocapiBasket) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var couponItems = ((_a = ocapiBasket.coupon_items) === null || _a === void 0 ? void 0 : _a.map(function (item) { return CouponItemDto.fromOcapi(item); })) || [];
        var productItems = ((_b = ocapiBasket.product_items) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ProductItemDto.fromOcapi(item); })) || [];
        var shipments = ((_c = ocapiBasket.shipments) === null || _c === void 0 ? void 0 : _c.map(function (item) { return ShipmentDto.fromOcapi(item); })) || [];
        var shippingMethods = ((_d = ocapiBasket.c_shippingMethods) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ShippingMethodDto.fromOcapi(item); })) || [];
        var shippingItems = ((_e = ocapiBasket.shipping_items) === null || _e === void 0 ? void 0 : _e.map(function (item) { return ShippingItemDto.fromOcapi(item); })) || [];
        var shippingMethodName = (_g = (_f = shipments[0]) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : "Estimated Shipping";
        var validationError = (_j = (_h = ocapiBasket._flash) === null || _h === void 0 ? void 0 : _h.find(function (item) { return item.type === "ValidateBasket"; })) === null || _j === void 0 ? void 0 : _j.message;
        var responseEvents = ((_k = ocapiBasket.c_responseEvents) === null || _k === void 0 ? void 0 : _k.map(function (item) { return ResponseEventDto.fromOcapi(item); })) || [];
        return new BasketDto(ocapiBasket.adjusted_merchandize_total_tax || 0, ocapiBasket.adjusted_shipping_total_tax || 0, couponItems, ocapiBasket.currency, ocapiBasket.basket_id, ocapiBasket.merchandize_total_tax, ocapiBasket.c_minicartCountOfItems, ocapiBasket.c_orderDiscount, ocapiBasket.order_total || 0, productItems, ocapiBasket.product_sub_total, ocapiBasket.c_basketTotalQuantity, ocapiBasket.product_total, shippingMethodName, shipments, shippingMethods, shippingItems, ocapiBasket.shipping_total || 0, ocapiBasket.shipping_total_tax || 0, ocapiBasket.tax_total || 0, validationError, responseEvents);
    };
    return BasketDto;
}());
export { BasketDto };
//# sourceMappingURL=BasketDto.js.map